<template>
  <b-col ref="siteInfo" class="site-info" v-if="site">
    <!-- <BasicSiteDetails :site="site" v-if="wizardStep === 'initials'"/> -->
    <!--! Change1 Make changes below (turn into accept section)   -->
    <AcceptSection title="General Site Information" :items="acceptance.initials" v-if="wizardStep === 'initials'" v-on:accept-toggle="toggleAccept" type="initials">
      <template #instruction>
      </template>
    </AcceptSection>
    <BasicSiteDetails :site="site" v-if="wizardStep === 'initials'"/>
    <!-- <b-row class="section-alert-gray" v-if="wizardStep === 'initial'">
      <b-col class="">
        I acknowledge I must complete the following Hazard ID <b>before</b> entering this site.
      </b-col>
    </b-row> -->

    <AcceptSection title="Specific Entry Conditions" :items="acceptance.specific" v-if="wizardStep === 'specific'" v-on:accept-toggle="toggleAccept" type="specific">
      <template #extra>
        <b-row class="section-alert-red" v-if="!isSectionComplete('specific')">
          <p><b>ALERT&nbsp;</b><br/></p>
          <p>You have indicated you do not comply with a Special Condition. Therefore, you are not permitted on this site. Please contact the Site Contact on <strong>{{site.forepersonMobile}}</strong>.</p>
        </b-row>
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.CRITICAL_HAZARDS" :items="acceptance.allCriticalRisks" v-if="wizardStep === 'allCriticalRisks'" v-on:accept-toggle="toggleAccept" type="allCriticalRisks">
      <template v-slot:item="{ item }">
        <span class="section-content-title-and-desc" v-html="item.risk"></span>
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.GENERAL_HAZARDS" :items="acceptance.standardRisks" v-if="wizardStep === 'standardRisks'" v-on:accept-toggle="toggleAccept" type="standardRisks">
      <template v-slot:item="{ item }">
        <span class="section-content-title-and-desc" v-html="item.risk"></span>
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.WORKSAFE_TASKS" :items="acceptance.tasks" v-if="wizardStep === 'tasks'" v-on:accept-toggle="toggleAccept" type="tasks">
      <template #instructions>
        Click each box to indicate compliance
      </template>
    </AcceptSection>

    <!-- ! New -->
    <AcceptSection :title="SectionTitles.MITIGATIONS_CONTROLS" :items="acceptance.mitigations" v-if="wizardStep === 'mitigations'" v-on:accept-toggle="toggleAccept" type="mitigations">
      <template #instructions>
        <p style="font-weight: 300;">The following General Site Safety Rules outline the key mitigations and controls for hazards onsite.</p>
        Click each box to indicate compliance
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.PPE_REQUIREMENTS" :items="acceptance.ppe" v-if="wizardStep === 'ppe'" v-on:accept-toggle="toggleAccept" type="ppe" btnClasses="" class="section-ppe">
      <template #instructions>
        The following PPE is required on this site. Click to confirm you are wearing the required items.
      </template>
      <template v-slot:item="{ item }">
        <ppe-icon :ppe="item.title"/>
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.SITE_SAFETY" :items="acceptance.safety" v-if="wizardStep === 'safety'" v-on:accept-toggle="toggleAccept" type="safety">
      <template v-slot:item="{ item }">
        <div v-for="(subitem, index) in item.list" v-bind:key="'div-item-' + SectionTitles.SITE_SAFETY + '-' + index">
          <span class="section-content-title-and-desc" v-html="subitem.title"></span><br/>
          <span v-if="subitem.detail" class="section-content-list" v-html="subitem.detail"></span><br/>
          <br/>
        </div>
      </template>
      <template #extra v-if="site.medicalCentreLatLng">
        <p class="text-center">See below for directions to medical centre</p>
        <GmapMap
          :center="latLngToObject(site.medicalCentreLatLng)"
          :zoom="15"
          map-type-id="roadmap"
          style="width: 100%; height: 300px;"
        >
          <GmapMarker
            :key="index"
            v-for="(m,index) in [{ position: latLngToObject(site.latLng) }, { position: latLngToObject(site.medicalCentreLatLng) }]"
            :position="m.position"
            :clickable="true"
            :draggable="false"
            :title="site.name"
          />
          <DirectionsRenderer
            travelMode='DRIVING'
            :origin="latLngToObject(site.latLng)"
            :destination="latLngToObject(site.medicalCentreLatLng)"
          />
        </GmapMap>
      </template>
    </AcceptSection>

    <AcceptSection :title="SectionTitles.PERSONAL_CONSENT" :items="acceptance.personal" v-if="wizardStep === 'personal'" v-on:accept-toggle="toggleAccept" type="personal">
      <template #instructions>
        Click to indicate acceptance
      </template>
    </AcceptSection>

    <div id="next-btn-wrapper">
      <b-row ref="next" class="container section-alert-dark next-btn-container justify-content-between py-2 px-3">
        <b-button variant="secondary" @click="dispatch('BACK')" class="w-50 mr-1 ml-n1">
          <font-awesome-icon icon="arrow-circle-left" size="lg" fixedWidth class="icon"/> Back
        </b-button>
        <b-button :disabled="nextDisabled" class="w-50 ml-1 mr-n1" :variant="nextDisabled ? 'secondary' : 'success'" @click="dispatch('NEXT')">
          Next <font-awesome-icon icon="arrow-circle-right" size="lg" fixedWidth class="icon"/>
        </b-button>
      </b-row>
    </div>
  </b-col>
<b-col v-else/>
</template>

<script>
import { debounce } from '@/lib/utils';
import BasicSiteDetails from '@/components/siteParts/BasicSiteDetails.vue';
import AcceptSection from '@/components/siteParts/AcceptSection.vue';
import {
  HAZARD_TYPE_CRITICAL,
  HAZARD_TYPE_STANDARD,
  HAZARD_TYPE_OTHER,
  mapHazards,
  SectionTitles, // eslint-disable-line no-unused-vars
} from '@/lib/generic-lists';
import PpeIcon from '@/components/siteParts/icons/PpeIcon.vue';
import DirectionsRenderer from '../../lib/direction-renderer';

//! Added
// const siteLoc = latLngToObject(this.site.LatLng);
// const medicalLoc = latLngToObject(this.site.medicalCentreLatLng);

export default {
  name: 'CommonSignIn',
  components: {
    BasicSiteDetails,
    AcceptSection,
    PpeIcon,
    DirectionsRenderer,
  },
  props: {
    site: Object,
  },
  data() {
    return {
      machine: {
        initials: { NEXT: 'specific', BACK: 'clear-site' },
        specific: { NEXT: 'allCriticalRisks', BACK: 'initials' },
        allCriticalRisks: { NEXT: 'standardRisks', BACK: 'specific' },
        standardRisks: { NEXT: 'tasks', BACK: 'allCriticalRisks' },
        tasks: { NEXT: 'mitigations', BACK: 'standardRisks' },
        mitigations: { NEXT: 'ppe', BACK: 'tasks' },
        ppe: { NEXT: 'safety', BACK: 'mitigations' },
        safety: { NEXT: 'personal', BACK: 'ppe' },
        personal: { NEXT: 'sign-in', BACK: 'safety' },
      },
      wizardStep: 'initials',
      HAZARD_TYPE_CRITICAL,
      HAZARD_TYPE_STANDARD,
      HAZARD_TYPE_OTHER,
      SectionTitles,
      mapHazards,
      acceptance: {
        //! Change1 this is added
        initials: [{
          text: 'I acknowledge I must complete the following Hazard ID before entering this site',
          accepted: false,
        }],
        specific: [
          { text: '<b>Site Induction</b><br/>You have completed the specific induction for the site', accepted: false },
          { text: '<b>General Personal Health</b><br/>You are in good health and understand the steps to follow personal health guidelines (wash hands, social distancing, cough into elbow, stay home if unwell).', accepted: false },
        ],
        allCriticalRisks: [],
        standardRisks: [],
        additionalRisks: [],
        tasks: [],
        mitigations: [
          { text: '<b>1. Plan your day</b>', accepted: false },
          { text: '<b>2. Take 5</b>', accepted: false },
          { text: '<b>3. Speak up</b>', accepted: false },
          { text: '<b>4. Know your limit</b>', accepted: false },
          { text: '<b>5. Check your gear</b>', accepted: false },
          { text: '<b>6. Wear your PPE</b>', accepted: false },
          { text: '<b>7. Wear your seatbelt</b>', accepted: false },
          { text: '<b>8. Check before you dig</b>', accepted: false },
          { text: '<b>9. Respect exclusion zones</b>', accepted: false },
          { text: '<b>10. Be drug free</b>', accepted: false },
          { text: '<b>11. Keep your site tidy</b>', accepted: false },
          { text: '<b>12. Stay fit and healthy</b>', accepted: false },
          { text: '<b>13. Look out for your mates</b>', accepted: false },
        ],
        ppe: [],
        safety: [],
        personal: [{
          text: 'I agree to the conditions of this Hazard ID and consent that my name, location and contact details are recorded as part of the Schick site sign-in process.',
          accepted: false,
        }],
      },
      scrolledFirst: true,
    };
  },
  mounted() {
    // risks
    this.acceptance.criticalRisks = mapHazards(this.site.hazards || []).filter((hazard) => hazard.type === HAZARD_TYPE_CRITICAL).map(this.formatHazard);
    this.acceptance.additionalRisks = mapHazards(this.site.hazards || []).filter((hazard) => hazard.type === HAZARD_TYPE_OTHER).map(this.formatOtherHazard);
    this.acceptance.allCriticalRisks = [...this.acceptance.criticalRisks, ...this.acceptance.additionalRisks];
    this.acceptance.standardRisks = mapHazards(this.site.hazards || []).filter((hazard) => hazard.type === HAZARD_TYPE_STANDARD).map(this.formatHazard);

    // If there are no critical risks
    if (this.acceptance.allCriticalRisks.length === 0) {
      this.acceptance.allCriticalRisks = [{ risk: 'There are NO critical site hazards on this site.', accepted: false }];
    }

    // If there are no standard risks
    if (this.acceptance.standardRisks.length === 0) {
      this.acceptance.standardRisks = [{ risk: 'There are NO general hazards on this site.', accepted: false }];
    }

    // WorkSafe Tasks
    if (this.site.tasks && this.site.tasks.length > 0) {
      this.acceptance.tasks = this.site.tasks.map((task) => ({ text: task, accepted: false }));
    } else {
      this.acceptance.tasks = [{ text: 'There are NO WorkSafe notifiable tasks on this site today.', accepted: false }];
    }

    // TODO: can PPE be empty?
    if (this.site.ppe && this.site.ppe.length > 0) {
      this.acceptance.ppe = this.site.ppe.map((ppe) => ({ title: ppe, accepted: false }));
    } else {
      this.acceptance.ppe = [{ title: 'No PPE required on this site', accepted: false }];
    }

    // safety
    const safetyList = [
      { title: '<b>First Aiders on Site</b>', detail: this.site.firstAiders.replace('\n', '<br/>'), accepted: false },
      { title: '<b>Emergency Wardens on Site</b>', detail: this.site.emergencyWardens.replace('\n', '<br/>'), accepted: false },
      { title: '<b>Emergency Evacuation Points</b>', detail: this.site.evacuationPoints.replace('\n', '<br/>'), accepted: false },
    ];

    // first aid kits may be null
    if (this.site.firstAidKits) {
      safetyList.push({ title: '<b>Location of First Aid Kits on Site</b>', detail: this.site.firstAidKits, accepted: false });
    }

    // medical centre should display last (just above the map)
    safetyList.push({ title: '<b>Nearest Medical Centre</b>', detail: this.site.localMedicalCentre, accepted: false });

    this.acceptance.safety = [{ list: safetyList }];

    this.handleScroll();
  },
  watch: {
    wizardStep() {
      this.$emit('update:wizardStep', this.wizardStep);
      this.scrollToTop();
    },
  },
  created() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  },
  computed: {
    nextDisabled() {
      if (!this.wizardStep) return true;
      switch (this.wizardStep) {
        case 'initial':
          return !this.scrolledFirst;
        default:
          return !this.isSectionComplete(this.wizardStep);
      }
    },
    responses() {
      const covidResponses = {};
      this.acceptance.specific.forEach((item) => {
        covidResponses[item.text] = 'Agree';
      });

      return {
        covid19: covidResponses,
        allCriticalRisks: 'Yes',
        standardRisks: 'Yes',
        tasks: 'Yes',
        ppe: 'Yes',
        safety: 'Yes',
        personal: 'Yes',
        site: this.site,
      };
    },
  },
  methods: {
    dispatch(event) {
      const action = this.machine[this.wizardStep][event];
      switch (action) {
        case 'clear-site':
          this.$emit('clear-site');
          break;
        case 'sign-in':
          this.$emit('complete', this.responses);
          break;
        default:
          this.wizardStep = action;
          setTimeout(() => window.scrollTo(0, 0), 100);
      }
    },
    formatOtherHazard(raw) {
      const hazard = { ...raw };
      if (hazard.risk.indexOf('<b>') !== 0) hazard.risk = `<b>${hazard.risk}</b>`; // eslint-disable-line no-param-reassign
      hazard.risk = hazard.risk.replace('&nbsp;&nbsp;', '').replace('\\', ''); // eslint-disable-line no-param-reassign
      if (hazard.mitigations) {
        hazard.risk = `${hazard.risk}<br/>Risk: ${hazard.mitigations}`;
      }
      hazard.accepted = false;
      return hazard;
    },
    formatHazard(raw) {
      const hazard = { ...raw };
      if (hazard.risk.indexOf('<b>') !== 0) hazard.risk = `<b>${hazard.risk}</b>`; // eslint-disable-line no-param-reassign
      hazard.risk = hazard.risk.replace('&nbsp;&nbsp;', '').replace('\\', ''); // eslint-disable-line no-param-reassign
      hazard.accepted = false;
      return hazard;
    },
    isSectionComplete(section) {
      return this.acceptance[section].reduce((acc, item) => acc && item.accepted, true);
    },
    scrollToTop() {
      window.scrollTo(0, this.$refs.siteInfo.offsetTop);
    },
    handleScroll() {
      if (this.scrolledFirst || this.wizardStep !== 'initial') {
        return;
      }

      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 58) {
        this.scrolledFirst = true;
      }
    },
    toggleAccept(type, index) {
      this.$set(this.acceptance[type], index, {
        ...this.acceptance[type][index],
        accepted: !this.acceptance[type][index].accepted,
      });
    },
    latLngToObject(latLng) {
      if (!latLng || latLng.trim().length === 0) return null;
      const parts = latLng.split(/,{1}\s{0,1}/g);
      return {
        lat: parseFloat(parts[0]),
        lng: parseFloat(parts[1]),
      };
    },
  },
};
</script>
